import PaiTextField from 'features/ui/base-components/pai-text-field';
import React from 'react';
import { BasicActionDialog } from '../../../ui/base-dialogs';

interface Props {
  open: boolean;
  name: string;

  handleTextFieldChange(type: string): (event: React.ChangeEvent<HTMLInputElement>) => void;

  handleClose(): void;

  handleProceed(): void;
}

const EditQuestionnaireDialog: React.FC<Props> = ({ open, name, handleTextFieldChange, handleClose, handleProceed }) => {
  return (
    <BasicActionDialog
      dialogTitle={'Fragebogen bearbeiten'}
      maxWidth={'xs'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'Ok'}
      open={open}
      handleClose={handleClose}
      handleProceed={handleProceed}
      proceedButtonDisabled={name.trim() === ''}
    >
      <PaiTextField value={name} placeholder={'Name zu bewertender Führungskraft...'} onChange={handleTextFieldChange('name')} />
    </BasicActionDialog>
  );
};

export default EditQuestionnaireDialog;
